<template>
	<v-container align-center>
		<h5 class="headline mb-5 text-center">{{ title }}</h5>
		<v-layout justify-center>
			<v-flex>
				<v-flex class="pos-rel">
					<input
						ref="inputUpload"
						type="file"
						@change="onFileChange"
						required
						class="input"
						style="display: none"
					/>
				</v-flex>
				<v-layout justify-center>
					<v-btn
						round
						:dark="true"
						:color="themeInputColor"
						:loading="isInvoiceUploading"
						@click="uploadInvoices"
					>
						Upload File
					</v-btn>
				</v-layout>
				<v-layout align-center justify-center>
					<div class="mt-3">
						<a target="_blank" :href="sampleCsv"
							>Download sample file</a
						>
					</div>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import {
	UPLOAD_MEDIA_TO_SERVER,
	UPLOAD_PRIMARY_DAY_FILE
} from "../../store/action-types";
import { JEET_11_CDN_BASE_LINK } from "@/store/config";

let filePayload = null;

export default {
	components: {},
	props: ["title", "themeInputColor"],
	data() {
		return {
			sampleCsv: `${JEET_11_CDN_BASE_LINK}/sample-csv/primaryDayAutomation.xlsx`,
			isInvoiceUploading: false,
			uploadKey: "retailAdminPrimaryDayUpload"
		};
	},
	methods: {
		uploadInvoices() {
			this.clearInput();
			this.$refs.inputUpload.click();
		},
		uploadFilePath(filePath) {
			this.$store
				.dispatch(UPLOAD_PRIMARY_DAY_FILE.dispatch, {
					fileUrl: filePath,
					baseToUse: "jeet11-retail"
				})
				.then(() => {})
				.catch(err => console.log(err))
				.finally(() => {
					this.isInvoiceUploading = false;
				});
		},
		clearInput() {
			this.$refs.inputUpload.value = "";
			this.payload = [];
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			filePayload = files[0];
			if (this.isInvoiceUploading) {
				return;
			}
			this.isInvoiceUploading = true;
			this.$store
				.dispatch(UPLOAD_MEDIA_TO_SERVER.dispatch, {
					key: this.uploadKey,
					file: filePayload,
					type: "csvUpload"
				})
				.then(data => {
					this.uploadFilePath(data.fileUrl);
				})
				.catch(err => console.log(err));
		}
	}
};
</script>

<style lang="scss"></style>
